import { Controller } from "@hotwired/stimulus"

// Carrousel souvenirs de l'accueil : défile tout seul, deux cartes à la fois.
// Il s'arrête au survol et au focus clavier (sinon impossible de lire ou de
// cliquer tranquillement), quand l'onglet passe en arrière-plan, et il ne
// démarre pas du tout si l'utilisateur a demandé « moins d'animations ».
export default class extends Controller {
  static targets = ["track"]
  static values = { interval: { type: Number, default: 5000 } }

  connect() {
    this.reducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    this.start()
  }

  disconnect() {
    this.stop()
  }

  start() {
    if (this.reducedMotion || this.timer) return
    this.timer = setInterval(() => this.advance(), this.intervalValue)
  }

  stop() {
    clearInterval(this.timer)
    this.timer = null
  }

  advance() {
    if (document.hidden) return
    this.next()
  }

  next() {
    const el = this.trackTarget
    const atEnd = el.scrollLeft + el.clientWidth >= el.scrollWidth - 1
    if (atEnd) el.scrollTo({ left: 0, behavior: "smooth" })
    else el.scrollBy({ left: this.step(), behavior: "smooth" })
  }

  prev() {
    const el = this.trackTarget
    if (el.scrollLeft <= 1) el.scrollTo({ left: el.scrollWidth, behavior: "smooth" })
    else el.scrollBy({ left: -this.step(), behavior: "smooth" })
  }

  // Une « page » = la largeur visible, soit deux cartes sur grand écran.
  step() {
    return this.trackTarget.clientWidth
  }
}
